module.exports = __webpack_public_path__ + "img/cm.d499030.png";